import React from "react";

function CharityIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 282.013 282.013"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          d="M221.77,218.706l-86.911-12.036l-34.057-34.053c-0.001-0.001-0.002-0.003-0.004-0.005c-1.261-1.264-1.262-3.318-0.01-4.573
		c0.824-0.823,1.788-0.946,2.289-0.946c0.498,0,1.456,0.122,2.271,0.939c0.002,0.002,0.004,0.003,0.006,0.005v0.001l25.749,25.748
		c0.001,0.001,0.002,0.001,0.003,0.003c0.001,0.001,0.002,0.002,0.003,0.003c0.073,0.074,0.155,0.135,0.23,0.208
		c0.112,0.103,0.223,0.21,0.339,0.305c3.78,3.493,8.594,5.261,13.422,5.261c5.07,0,10.145-1.928,14.01-5.784
		c7.712-7.726,7.71-20.29-0.005-28.006L88.418,95.087c-1.407-1.407-3.314-2.197-5.304-2.197H7.5c-4.143,0-7.5,3.358-7.5,7.5
		c0,4.142,3.357,7.5,7.5,7.5h72.508l68.489,68.489c1.872,1.873,1.87,4.925,0.006,6.792c-1.873,1.87-4.926,1.87-6.799,0
		c-0.003-0.003-0.007-0.006-0.01-0.009L115.97,157.44c-0.001-0.001-0.002-0.003-0.004-0.005c-0.002-0.002-0.004-0.003-0.006-0.005
		v-0.001c-0.003-0.003-0.007-0.006-0.01-0.009c-3.436-3.436-8.008-5.328-12.873-5.328c-4.869,0-9.447,1.895-12.898,5.342
		c-6.908,6.921-7.066,18.064-0.512,25.205c0.044,0.054,0.096,0.103,0.141,0.155c0.127,0.135,0.238,0.278,0.369,0.41
		c0.002,0.002,0.004,0.004,0.007,0.006l0.001,0.001l35.849,35.846c1.155,1.155,2.655,1.901,4.274,2.126l89.338,12.371
		c1.683,0.249,4.864,1.373,4.864,3.857c0.002,1.355-0.688,2.247-1.099,2.659c-0.413,0.413-1.309,1.106-2.67,1.106h-99.917
		l-79.523-79.533c-1.406-1.406-3.314-2.197-5.304-2.197H7.5c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5,7.5,7.5h25.391l79.523,79.533
		c1.406,1.406,3.314,2.197,5.304,2.197h103.023c5.019,0,9.735-1.955,13.282-5.505c3.543-3.547,5.492-8.262,5.486-13.268
		C239.51,227.937,232.242,220.252,221.77,218.706z"
        />
        <path
          d="M236.208,25.836c-11.389,0-22.642,4.231-31.371,11.579c-8.728-7.349-19.978-11.579-31.363-11.579
		c-25.685,0-45.805,20.12-45.805,45.806c0,30.499,26.108,53.634,62.273,85.616l9.6,9.572c1.464,1.46,3.38,2.189,5.296,2.189
		c1.915,0,3.83-0.729,5.293-2.186l9.611-9.574c36.162-31.98,62.271-55.117,62.271-85.617
		C282.013,45.956,261.892,25.836,236.208,25.836z M209.637,146.17c-0.111,0.098-0.22,0.2-0.324,0.305l-4.473,4.455l-4.466-4.453
		c-0.106-0.106-0.215-0.209-0.327-0.308c-36.645-32.407-57.378-51.847-57.378-74.528c0-17.562,13.243-30.806,30.805-30.806
		c9.569,0,19.393,4.588,25.636,11.973c1.425,1.685,3.521,2.658,5.728,2.658c2.207,0,4.303-0.972,5.728-2.658
		c6.244-7.385,16.07-11.973,25.644-11.973c17.562,0,30.805,13.244,30.805,30.806C267.013,94.325,246.28,113.764,209.637,146.17z"
        />
      </g>
    </svg>
  );
}

export default CharityIcon;
